// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".task-list-item>.task-list-item__drag-handle{align-self:center;margin-right:16px!important;cursor:move}.task-list-item .task-list-item__details{display:inline-flex}.task-list-item .task-list-item__details .v-chip{margin-right:8px}", ""]);
// Exports
module.exports = exports;
